import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { CannedParams } from '../../../types/Content';
import { EmailModulesData } from '../../../types/EmailModules';
import { marketingEnhancementDefaults } from '../../../context/MarkettingPromptContext/constants';

export type ModuleOptionsType = {
  id: string;
  label: string;
  name: string;
};

type OptionsType = {
  loading: boolean;
  options: (CannedParams | EmailModulesData)[];
  extendedLibraryItems?: CannedParams[];
  isFetched?: boolean;
  isSuccess?: boolean;
};

export type FilterOptionTypes = {
  countriesOptions: OptionsType;
  actionsOptions: OptionsType;
  brandsOptions: OptionsType;
  indicationsOptions: OptionsType;
  audiencesOptions: OptionsType;
  segmentsOptions: OptionsType;
  primaryMessagesOptions: OptionsType;
  tonesOptions: OptionsType;
  channelsOptions: OptionsType;
  contentStyleOptions: OptionsType;
  toneLevelOptions: OptionsType;
  emailModuleOptions: OptionsType;
  languageOptions: OptionsType;
};

export type FiltersStateTypes = {
  countriesOptions: OptionsType;
  actionsOptions: OptionsType;
  brandsOptions: OptionsType;
  indicationsOptions: OptionsType;
  audiencesOptions: OptionsType;
  segmentsOptions: OptionsType;
  primaryMessagesOptions: OptionsType;
  tonesOptions: OptionsType;
  channelsOptions: OptionsType;
  contentStyleOptions: OptionsType;
  toneLevelOptions: OptionsType;
  destinationFormatOptions: OptionsType;
  emailModuleOptions: OptionsType;
  languageOptions: OptionsType;
  platformOptions: OptionsType;
  action: string;
  brand: string;
  country: string;
  indication: string;
  language: string;
  primaryMessage: string[];
  segment: string;
  targetAudience: string;
  tone: string;
  contentStyle: string;
  inclusions: string;
  exclusions: string;
  daring: boolean;
  compassionate: boolean;
  emailModules: string;
  destinationFormat: string;
  context?: string;
  unbranded: boolean;
  toneLevel: string;
  platform: string;
  contentType: string;
  extendedLibrary: boolean;
};

export const filtersStateSegment = stateSegmentWithReset<FiltersStateTypes>({
  countriesOptions: { loading: false, options: [] },
  actionsOptions: { loading: false, options: [] },
  brandsOptions: { loading: false, options: [] },
  indicationsOptions: { loading: false, options: [] },
  audiencesOptions: { loading: false, options: [] },
  segmentsOptions: { loading: false, options: [] },
  primaryMessagesOptions: { loading: false, options: [] },
  tonesOptions: { loading: false, options: [] },
  channelsOptions: { loading: false, options: [] },
  contentStyleOptions: {
    loading: false,
    options: marketingEnhancementDefaults.currentAvailableContentStyleOptions,
  },
  toneLevelOptions: {
    loading: false,
    options: marketingEnhancementDefaults.currentAvailableToneLevelOptions,
  },
  destinationFormatOptions: { loading: false, options: [] },
  emailModuleOptions: { loading: false, options: [], isFetched: false },
  languageOptions: { loading: false, options: [] },
  platformOptions: { loading: false, options: [] },
  platform: '',
  action: '',
  brand: '',
  country: '',
  indication: '',
  language: '',
  primaryMessage: [],
  segment: '',
  targetAudience: '',
  tone: '',
  toneLevel: marketingEnhancementDefaults.currentSelectedToneLevel,
  contentStyle: marketingEnhancementDefaults.currentSelectedContentStyle,
  inclusions: '',
  exclusions: '',
  daring: false,
  compassionate: false,
  emailModules: '',
  destinationFormat: '',
  context: '',
  unbranded: false,
  extendedLibrary: false,
  contentType: '',
});

filtersStateSegment.debugLabel = 'filtersStateSegment';
